import React from 'react';
import PanelGroup from '@creditflowresearch/uilib/PanelGroup';
import FaqItem, { IFaqItemProps } from './FaqItem';

import styles from './faqPanel.module.scss';

interface IProps {
  data: IFaqItemProps[],
  headerTitle?: string,
}

const FaqPanel = ({
  data,
  headerTitle = 'Frequently Asked Questions',
} : IProps) => (
  <div className={ styles.panelContainer }>
    <div className={ styles.header }>
      <div className={ styles.headerTitle }>
        { headerTitle }
      </div>
    </div>

    <PanelGroup
      dataTest="faqPanelGroup"
      className={ styles.faqPanelGroup }
    >
      {
        data.map((item) => <FaqItem key={ item.hash } { ...item } />)
      }
    </PanelGroup>
  </div>
);

export default FaqPanel;
